import {AbstractControl, FormControl} from '@angular/forms';

export class ErrorLabel {
  /**
   * Funzione di check che restituisce un booleano
   */
  private _checkFn: (control?: FormControl) => boolean;

  /**
   * Messaggio di errore da visualizzare
   */
  private _message: string;

  /**
   * Eventuali parametri da passare al messaggio di errore
   */
  private _messageParams: any;

  /**
   * Colore della label; di default è di colore rosso
   */
  private _color: string;

  constructor(checkFn: (control?: FormControl | AbstractControl) => boolean, message: string, messageParams?: any, color?: string) {
    this._checkFn = checkFn;
    this._message = message;
    this._messageParams = messageParams || {};
    this._color = color || 'text-danger';
  }

  get checkFn(): (control?: FormControl | AbstractControl) => boolean {
    return this._checkFn;
  }

  set checkFn(value: (control?: FormControl | AbstractControl) => boolean) {
    this._checkFn = value;
  }

  get message(): string {
    return this._message;
  }

  set message(value: string) {
    this._message = value;
  }

  get messageParams(): any {
    return this._messageParams;
  }

  set messageParams(value: any) {
    this._messageParams = value;
  }

  get color(): string {
    return this._color;
  }

  set color(value: string) {
    this._color = value;
  }
}
